// extracted by mini-css-extract-plugin
module.exports = {"container":"_2wzmUrqUmqW66dNYfB9B4q"};